import { useEffect, useState } from 'react';
import api from '../api';

/**
 * Hooks reutilizables para consumir la API.
 * Si la API falla, devuelven los datos mock como fallback.
 */

export function useApi(fetcher, fallback, deps = []) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetcher()
      .then((result) => {
        if (!alive) return;
        if (result !== null && result !== undefined) {
          setData(result);
          setError(null);
        } else {
          setError('using_fallback');
        }
      })
      .catch((e) => {
        if (alive) setError(e.message);
      })
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}

// Hooks especificos
export const useServerStatus = () => useApi(() => api.status(), null);
export const useServerStats = () => useApi(() => api.stats(), null);
export const useTopPlayers = (type = 'pvp', limit = 10) =>
  useApi(() => api.topPlayers(type, limit), null, [type, limit]);
export const useTopClans = (limit = 10) =>
  useApi(() => api.topClans(limit), null, [limit]);
export const useCastles = () => useApi(() => api.castles(), null);
export const useHeroes = () => useApi(() => api.heroes(), null);
